import { IconNameAndCategoryString } from '../../Icon'
import { RatingSelect } from '../../common/RatingSelect'
import { NpsStep } from './NPSStepBasePage'
import {
    FieldIds,
    NPSFieldId,
    NPSStepId,
    NPSStepProps,
    SCORE_HIGH,
    SCORE_LOW,
    StepIds,
} from './types'
import { NPSRecordState } from './NPSViewModel'
import { NPSWorkflowStep } from './useNPSFormWorkflowCoordinator'
import { validateScore } from './validation'

const SATISFACTION_FIELDS: {
    id: NPSFieldId
    icon: IconNameAndCategoryString
}[] = [
    {
        id: FieldIds.CUSTOMER_SERVICE_SATISFACTION,
        icon: 'phone.large',
    },
    {
        id: FieldIds.MESSAGING_SATISFACTION,
        icon: 'message.large',
    },
    {
        id: FieldIds.SCHEDULING_SATISFACTION,
        icon: 'calendar.large',
    },
    {
        id: FieldIds.CLIENT_EXPERIENCE_SATISFACTION,
        icon: 'user3.large',
    },
    {
        id: FieldIds.MAKE_MONEY_SATISFACTION,
        icon: 'dollar7.large',
    },
]

export const SATISFACTION_RATINGS_STEP = {
    id: StepIds.SATISFACTION_RATINGS,
    validate: ({ getFieldValue }: NPSRecordState) => {
        return SATISFACTION_FIELDS.every((field) => validateScore(getFieldValue(field.id)))
    },
} as const satisfies NPSWorkflowStep<NPSStepId>

export function NPSStepSatisfactionRatingPage(props: NPSStepProps) {
    return (
        <NpsStep
            {...props}
            title="Rate your satisfaction"
            subtitle="Based on the your recent experience with the following PocketSuite features, please rate your satisfaction."
            fieldGroups={[
                SATISFACTION_FIELDS.map(({ id, icon }) => ({
                    id,
                    icon,
                    render: (value: unknown, onChange: (x: unknown) => void) => (
                        <RatingSelect
                            value={typeof value === 'number' ? value : undefined}
                            onChange={onChange}
                            lower={SCORE_LOW}
                            upper={SCORE_HIGH}
                            lowSentiment="Highly dissatisfied"
                            highSentiment="Highly satisfied"
                        />
                    ),
                })),
            ]}
        />
    )
}
